<template>
    <div class="action-set-process-modal">
        <ProcessModal
            :is-open="isOpen"
            :title="$t('funnel.edit.actionSet.create.title')"
            :summary-text="$t('funnel.edit.actionSet.create.summary')"
            :show-save="enabledSaveButton"
            :process-tip-text="$t('funnel.edit.actionSet.create.tip.warning')"
            show-warning-icon
            @close-modal="closeModal"
            @update-config="updateConfig"
        >
            <template #processParameters>
                <DsMultiselect
                    v-model="actionSetTypeId"
                    bind-value-only
                    required
                    class="action-set-type-select"
                    :placeholder="$t('funnel.edit.actionSet.create.placeholder')"
                    :options="actionSetOptions"
                    @input="loadRuleItems"
                />
                <!-- eslint-disable vue/no-v-html -->
                <div class="action-set-list-text" v-html="actionSetListsText" />
                <!-- eslint-enable vue/no-v-html -->
            </template>
        </ProcessModal>
    </div>
</template>

<script>
import { getActionDescription, getAllActionSet } from './action.set.api';
import ProcessModal from '../processModal/ProcessModal.vue';

export default {
    components: {
        ProcessModal,
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        appInfo: {
            type: Object,
            required: true,
        },
        cell: {
            type: Object,
            default: () => ({
                value: {
                    actionSetId: '',
                    reason: '',
                },
            }),
        },
    },
    emits: ['close-modal', 'update-cell-value'],
    data() {
        return {
            actionSetTypeId: '',
            actionSetOptions: [],
            actionSetListsText: '',

        };
    },
    computed: {
        enabledSaveButton() {
            return !!this.actionSetTypeId;
        },
    },
    async mounted() {
        await this.loadAllActionsSet();
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        },
        updateConfig() {
            const cell = { ...this.cell };

            cell.value = cell.value || {};
            cell.value.actionSetId = `${this.actionSetTypeId}L`;
            cell.value.reason = '';

            this.$emit('update-cell-value', { cell });
        },
        async loadAllActionsSet() {
            const tempActionSetId = this.cell?.value?.actionSetId?.toString()?.replace('L', '');
            const actionSetMap = await getAllActionSet();

            this.actionSetOptions = Object.entries(actionSetMap).map(([value, label]) => {
                return { value, label };
            });

            this.actionSetTypeId = this.actionSetOptions.find((action) => action.value === tempActionSetId)?.value ?? '';

            if (this.actionSetTypeId) {
                await this.loadRuleItems();
            }
        },
        async loadRuleItems() {
            this.actionSetListsText = '';

            const textContentItems = await getActionDescription(this.actionSetTypeId);

            this.actionSetListsText = textContentItems;
        },
    },
};
</script>

<style lang="scss" scoped>
.action-set-list-text {
    font-size: $spacing-200;
    line-height: $spacing-300;
    margin-bottom: $spacing-300;
}
</style>
